export const primaryDefaultColour = "#171542";
export const secondaryDefaultColour = "#ffd300";